// extracted by mini-css-extract-plugin
export default {"title":"NavBarItem_title__efcsQ","title__hide":"NavBarItem_title__hide__sD-bS","img":"NavBarItem_img__XBRrL"};